module.exports = __webpack_public_path__ + "media/images/placeholder-icon-nav-8a6979ce04cb2f54af2fe4f4fb857524.svg";